import { FC, useCallback, useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import PersonIcon from '@mui/icons-material/Person';
import PowerIcon from '@mui/icons-material/PowerSettingsNew';
import {
  Avatar,
  ClickAwayListener,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material';
import Button from '@mui/material/Button';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import { useStoreDispatch, useStoreSelector } from 'src/hooks/store';
import PrivateContext from 'src/routes/Private/PrivateContext';
import api from 'src/services/api';
import { AuthActions } from 'src/store/ducks/auth';
import { handleErrors } from 'src/utils/errors';

const UserMenu: FC = () => {
  const userMenuRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const user = useStoreSelector((state) => state.auth.user);
  const dispatch = useStoreDispatch();
  const history = useHistory();
  const { startLayoutLoading, stopLayoutLoading } = useContext(PrivateContext);

  const handleClick = useCallback(() => setIsOpen((value) => !value), []);

  const handleLogout = async () => {
    try {
      startLayoutLoading();
      setIsOpen(false);

      await api.admin.auth.logout();

      dispatch(AuthActions.authLogout());
      history.push('/');
    } catch (error) {
      handleErrors(error);
    } finally {
      stopLayoutLoading();
    }
  };

  const goTo = (path: string) => {
    setIsOpen(false);
    history.push(path);
  };

  return (
    <>
      <Button
        endIcon={<Avatar src={user?.photo} sx={{ width: 24, height: 24 }} />}
        ref={userMenuRef}
        color="inherit"
        onClick={handleClick}
      >
        {user?.name}
      </Button>

      <Popper
        open={isOpen}
        anchorEl={userMenuRef.current}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={() => setIsOpen(false)}>
                <MenuList>
                  <MenuItem onClick={() => goTo('/perfil')}>
                    <ListItemIcon>
                      <PersonIcon />
                    </ListItemIcon>
                    <ListItemText primary="Perfil" />
                  </MenuItem>

                  <Divider />

                  <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                      <PowerIcon />
                    </ListItemIcon>
                    <ListItemText primary="Sair" />
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default UserMenu;
